import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import { ApiResultModel as QuoteListApiResultModel } from "@WhiteCap/Store/Service/OsnQuotes/QuoteListService";
import { Draft } from "immer";

export interface OsnQuoteListDataModel {
    isLoading: boolean;
    quoteData: QuoteListApiResultModel;
    filtersOpen: boolean;
    filters: QuoteListFilters;
}

export interface QuoteListFilters {
    quoteNumber?: string;
    createdStartDate?: string;
    createdEndDate?: string;
    expiredStartDate?: string;
    expiredEndDate?: string;
    deliverTo?: string;
    branchContact?: string;
    jobsite?: string;
    sortDirection?: string;
}

const initialState: OsnQuoteListDataModel = {
    isLoading: false,
    quoteData: {
        pageNumber: 1,
        pageSize: 24,
        totalQuotes: 0,
    },
    filtersOpen: false,
    filters: {
        quoteNumber: "",
        createdStartDate: "",
        createdEndDate: "",
        expiredStartDate: "",
        expiredEndDate: "",
        deliverTo: "",
        branchContact: "",
        jobsite: "",
        sortDirection: "",
    },
};

type FilterName =
    | "quoteNumber"
    | "createdStartDate"
    | "createdEndDate"
    | "expiredStartDate"
    | "expiredEndDate"
    | "deliverTo"
    | "branchContact"
    | "jobsite"
    | "sortDirection";

const osnQuoteListReducer = {
    "Custom/OsnQuoteList/BeginLoadQuoteList": (draft: Draft<OsnQuoteListDataModel>) => {
        draft.isLoading = true;
    },
    "Custom/OsnQuoteList/LoadQuoteListError": (draft: Draft<OsnQuoteListDataModel>) => {
        draft.isLoading = true;
    },
    "Custom/OsnQuoteList/CompleteLoadQuoteList": (
        draft: Draft<OsnQuoteListDataModel>,
        action: {
            result: QuoteListApiResultModel;
        },
    ) => {
        draft.quoteData = action.result;
        draft.isLoading = false;
    },
    "Custom/OsnQuoteList/ToggleFiltersOpenState": (draft: Draft<OsnQuoteListDataModel>) => {
        draft.filtersOpen = !draft.filtersOpen;
    },
    "Custom/OsnQuoteList/UpdateFilter": (
        draft: Draft<OsnQuoteListDataModel>,
        action: { name: FilterName; value: string },
    ) => {
        draft.filters[action.name] = action.value;
    },
    "Custom/OsnQuoteList/UpdateFilters": (
        draft: Draft<OsnQuoteListDataModel>,
        action: { filtersObj: QuoteListFilters },
    ) => {
        draft.filters = {...draft.filters, ...action.filtersObj};
    },
};

export default createTypedReducerWithImmer(initialState, osnQuoteListReducer);
